import { render, staticRenderFns } from "./Showcase.vue?vue&type=template&id=22446ece&scoped=true&"
import script from "./Showcase.vue?vue&type=script&lang=js&"
export * from "./Showcase.vue?vue&type=script&lang=js&"
import style0 from "./Showcase.vue?vue&type=style&index=0&id=22446ece&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22446ece",
  null
  
)

export default component.exports